/**
 * Product Detail Desk — JS
 * Snap scroll (Lenis), sliders, modal planta (iframe), mapa produtos, dropdown.
 */

(function () {
  const root = document.getElementById('product-detail-desk');
  if (!root) return;

  // Mobile bypass: se estiver em viewport mobile, redireciona para a versão v3.
  if (window.innerWidth <= 768) {
    const slug = root.dataset.slug || '';
    if (slug) {
      window.location.replace('/produto-v3/' + slug);
      return;
    }
  }

  /* ════════════════════════════════════
     LENIS SNAP SCROLL
     ════════════════════════════════════ */
  // Defensive: kill any global Lenis (from main.js/scrollLenis.js) so it doesn't
  // double-bind wheel/touch and fight the snap. scrollLenis.js already skips
  // when #product-detail-desk exists, but we guard against script-order races.
  if (window.lenis && typeof window.lenis.destroy === 'function') {
    try { window.lenis.destroy(); } catch (e) { /* noop */ }
    window.lenis = null;
  }

  let lenis;
  if (typeof Lenis !== 'undefined') {
    lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: false,
      smoothTouch: false,
    });
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    window.lenis = lenis;
  }

  if (history.scrollRestoration) history.scrollRestoration = 'manual';
  window.scrollTo(0, 0);

  /* ════════════════════════════════════
     SPLASH VIDEO — garantir autoplay
     ════════════════════════════════════ */
  const splashVideo = root.querySelector('.splash__video');
  if (splashVideo) {
    const tryPlay = () => splashVideo.play().catch(() => { });
    if (splashVideo.readyState >= 2) {
      tryPlay();
    } else {
      splashVideo.addEventListener('loadeddata', tryPlay, { once: true });
    }
    window.addEventListener('load', tryPlay, { once: true });
  }

  // Coleta TODAS as seções diretamente filhas de #product-detail-desk
  let sectionsSnap = Array.from(root.querySelectorAll(':scope > .section-snap'));
  let currentIndex = 0;
  let isScrollingSection = false;
  let scrollLockTimer;
  let lastScrollTime = 0;

  function scrollToCurrent(immediate = false) {
    const target = sectionsSnap[currentIndex];
    if (!target) { isScrollingSection = false; return; }
    if (isScrollingSection && !immediate) return;

    isScrollingSection = true;
    clearTimeout(scrollLockTimer);
    updateActiveSection();

    if (lenis) {
      lenis.scrollTo(target, {
        duration: immediate ? 0 : 1.2,
        immediate: immediate,
        lock: true,
        force: true,
        onComplete: () => {
          scrollLockTimer = setTimeout(() => { isScrollingSection = false; }, 150);
        }
      });
    } else {
      target.scrollIntoView({ behavior: immediate ? 'auto' : 'smooth' });
      scrollLockTimer = setTimeout(() => { isScrollingSection = false; }, 1200);
    }

    if (immediate) {
      isScrollingSection = false;
      updateActiveSection();
    } else {
      scrollLockTimer = setTimeout(() => { isScrollingSection = false; }, 1500);
    }
  }

  function updateActiveSection() {
    sectionsSnap.forEach((sec, idx) => {
      if (!sec) return;
      const isActive = idx === currentIndex;
      if (isActive && !sec.classList.contains('is-active')) {
        sec.classList.add('is-active');
        // Notifica os sliders (via custom event)
        sec.dispatchEvent(new CustomEvent('pdesk:active'));

        // Curvas SVG da seção dark
        if (sec.classList.contains('planta--dark')) {
          const paths = sec.querySelectorAll('.draw-path');
          if (typeof gsap !== 'undefined' && paths.length) {
            gsap.set(paths, { visibility: 'visible' });
            paths.forEach((path, i) => {
              const length = path.getTotalLength();
              gsap.fromTo(path,
                { strokeDasharray: length, strokeDashoffset: length },
                { strokeDashoffset: 0, duration: 4 + i, ease: 'power1.inOut', delay: i * 0.5 }
              );
            });
          }
        }
      } else if (!isActive) {
        sec.classList.remove('is-active');
        if (sec.classList.contains('planta--dark') && typeof gsap !== 'undefined') {
          const paths = sec.querySelectorAll('.draw-path');
          gsap.set(paths, { visibility: 'hidden' });
        }
      }
    });

    // Inversão nav-dark para seções claras (planta sem dark, rodape)
    const current = sectionsSnap[currentIndex];
    if (current) {
      const isLight = current.classList.contains('planta') && !current.classList.contains('planta--dark')
        || current.classList.contains('rodape');
      document.body.classList.toggle('pdesk-on-light', !!isLight);
    }

    // Botão scroll
    const scrollBtn = document.getElementById('btn-scroll');
    if (scrollBtn && current) {
      const isLight = current.classList.contains('planta') && !current.classList.contains('planta--dark');
      const isRodape = current.classList.contains('rodape');
      scrollBtn.classList.toggle('section-scroll--gold', isLight);
      if (typeof gsap !== 'undefined') {
        gsap.to(scrollBtn, { opacity: isRodape ? 0 : 1, pointerEvents: isRodape ? 'none' : 'auto', duration: 0.4 });
      } else {
        scrollBtn.style.opacity = isRodape ? 0 : 1;
        scrollBtn.style.pointerEvents = isRodape ? 'none' : 'auto';
      }
    }

    updateFabPills(current);
  }

  /* ════════════════════════════════════
     FAB PILLS — visibilidade por seção ativa
     ════════════════════════════════════ */
  const pillTour     = document.getElementById('pill-tour');
  const pillConsultor = document.getElementById('pill-consultor');
  const pillTour360  = document.getElementById('pill-tour-360');

  function updateFabPills(section) {
    if (!section) return;
    const cls = section.classList;

    const noPill = cls.contains('splash') || cls.contains('produtos')
      || cls.contains('contato') || cls.contains('rodape');

    const isClubLike = cls.contains('club') || cls.contains('gardens') || cls.contains('rooftop-info');
    const isPlanta = cls.contains('planta') && !cls.contains('planta--dark');
    const isHeroSlider = cls.contains('hero');

    pillTour?.classList.toggle('is-visible', !noPill && isClubLike);
    pillConsultor?.classList.toggle('is-visible', !noPill && isPlanta);
    pillTour360?.classList.toggle('is-visible', !noPill && isHeroSlider);
  }

  /* ════════════════════════════════════
     INPUT HANDLERS
     ════════════════════════════════════ */
  // Com um modal aberto (planta/tour) o snap não pode navegar — o wheel/touch
  // pertence ao modal (zoom/pan) e o body já está com overflow hidden.
  function isOverlayOpen() {
    return document.getElementById('plantaModal')?.classList.contains('planta-modal--open')
      || document.getElementById('tourModal')?.classList.contains('is-open');
  }

  let wheelAccumulator = 0;
  let wheelTimer;
  window.addEventListener('wheel', (e) => {
    if (isOverlayOpen()) { wheelAccumulator = 0; return; }
    e.preventDefault();
    const now = Date.now();
    if (isScrollingSection || (now - lastScrollTime < 1100)) {
      wheelAccumulator = 0; return;
    }
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;

    wheelAccumulator += e.deltaY;
    clearTimeout(wheelTimer);
    wheelTimer = setTimeout(() => { wheelAccumulator = 0; }, 150);

    const threshold = 15;
    if (Math.abs(wheelAccumulator) >= threshold) {
      const direction = wheelAccumulator > 0 ? 1 : -1;
      wheelAccumulator = 0;
      if (direction > 0 && currentIndex < sectionsSnap.length - 1) {
        lastScrollTime = now; currentIndex++; scrollToCurrent();
      } else if (direction < 0 && currentIndex > 0) {
        lastScrollTime = now; currentIndex--; scrollToCurrent();
      }
    }
  }, { passive: false });

  let touchStartY = 0;
  window.addEventListener('touchstart', (e) => { touchStartY = e.touches[0].clientY; }, { passive: false });
  window.addEventListener('touchmove', (e) => {
    if (isOverlayOpen()) return;
    e.preventDefault();
  }, { passive: false });
  window.addEventListener('touchend', (e) => {
    if (isOverlayOpen()) return;
    const now = Date.now();
    if (isScrollingSection || (now - lastScrollTime < 1200)) return;
    const touchEndY = e.changedTouches[0].clientY;
    const deltaY = touchStartY - touchEndY;
    if (Math.abs(deltaY) < 40) return;
    if (deltaY > 40 && currentIndex < sectionsSnap.length - 1) {
      lastScrollTime = now; isScrollingSection = true; currentIndex++; scrollToCurrent();
    } else if (deltaY < -40 && currentIndex > 0) {
      lastScrollTime = now; isScrollingSection = true; currentIndex--; scrollToCurrent();
    }
  }, { passive: false });

  window.addEventListener('keydown', (e) => {
    if (isOverlayOpen()) return;
    if (['ArrowDown', 'PageDown', 'Space'].includes(e.code)) {
      e.preventDefault();
      if (!isScrollingSection && currentIndex < sectionsSnap.length - 1) { currentIndex++; scrollToCurrent(); }
    } else if (['ArrowUp', 'PageUp'].includes(e.code)) {
      e.preventDefault();
      if (!isScrollingSection && currentIndex > 0) { currentIndex--; scrollToCurrent(); }
    }
  });

  document.getElementById('btn-scroll')?.addEventListener('click', () => {
    if (isScrollingSection || (Date.now() - lastScrollTime < 1000)) return;
    if (currentIndex < sectionsSnap.length - 1) {
      lastScrollTime = Date.now();
      currentIndex++;
      scrollToCurrent();
    }
  });

  root.querySelector('.splash .splash__cta')?.addEventListener('click', (e) => {
    e.preventDefault();
    if (isScrollingSection || (Date.now() - lastScrollTime < 1000)) return;
    if (currentIndex < sectionsSnap.length - 1) {
      lastScrollTime = Date.now();
      currentIndex++;
      scrollToCurrent();
    }
  });

  /* ════════════════════════════════════
     SLIDER FACTORY (genérico para cada .hero)
     ════════════════════════════════════ */
  function initSlider(section) {
    const slideEls = section.querySelectorAll('.slide');
    if (slideEls.length < 1) return;

    const headlineEl = section.querySelector('.headline');
    const bodyEl = section.querySelector('.body-text');
    const labelEl = section.querySelector('.slide-label');
    const card = section.querySelector('.content-card');
    const progItems = section.querySelectorAll('.prog-item');
    const btnPrev = section.querySelector('[data-slider-prev]');
    const btnNext = section.querySelector('[data-slider-next]');

    // Coleta dados dos slides (data-headline, data-body, data-label)
    const slides = Array.from(slideEls).map(el => ({
      label: el.dataset.label || '',
      headline: el.dataset.headline || '',
      body: el.dataset.body || ''
    }));

    let current = 0;
    let isAnimating = false;
    let autoTimer, progTimeout;

    function startProgressBar() {
      if (!progItems.length || !progItems[current]) return;
      clearTimeout(progTimeout);
      progItems.forEach((item, i) => {
        item.classList.toggle('active', i === current);
        const fill = item.querySelector('.prog-fill');
        if (fill) {
          fill.getAnimations().forEach(a => a.cancel());
          fill.style.width = '0%';
        }
      });
      const fill = progItems[current].querySelector('.prog-fill');
      progTimeout = setTimeout(() => {
        if (fill) fill.animate([{ width: '0%' }, { width: '100%' }], { duration: 6000, fill: 'forwards', easing: 'linear' });
      }, 650);
    }

    function goTo(next, direction = 'forward') {
      if (isAnimating || next === current || next < 0 || next >= slides.length) return;
      isAnimating = true;
      const prev = current;
      current = next;
      const isForward = direction === 'forward';
      const prevSlide = slideEls[prev];
      const nextSlide = slideEls[next];

      if (card) { card.style.opacity = '0'; card.style.transform = 'translateY(22px)'; }

      prevSlide.classList.add('exiting', isForward ? 'forward' : 'backward');
      prevSlide.classList.remove('active');
      nextSlide.classList.add('entering', isForward ? 'forward' : 'backward');

      setTimeout(() => {
        prevSlide.classList.remove('exiting', 'forward', 'backward');
        nextSlide.classList.remove('entering', 'forward', 'backward');
        nextSlide.classList.add('active');
        if (headlineEl && slides[current].headline) headlineEl.innerHTML = slides[current].headline;
        if (bodyEl && slides[current].body) bodyEl.textContent = slides[current].body;
        if (labelEl && slides[current].label) labelEl.innerHTML = slides[current].label;
        startProgressBar();
        setTimeout(() => { if (card) { card.style.opacity = ''; card.style.transform = ''; } }, 120);
        isAnimating = false;
      }, 1100);
    }

    function startAuto() {
      clearInterval(autoTimer);
      if (slides.length < 2) return;
      autoTimer = setInterval(() => goTo((current + 1) % slides.length), 6500);
    }

    function stopAuto() { clearInterval(autoTimer); clearTimeout(progTimeout); }

    btnNext?.addEventListener('click', () => { goTo((current + 1) % slides.length, 'forward'); startAuto(); });
    btnPrev?.addEventListener('click', () => { goTo((current - 1 + slides.length) % slides.length, 'backward'); startAuto(); });
    progItems.forEach(item => {
      item.addEventListener('click', () => {
        const next = parseInt(item.dataset.idx);
        goTo(next, next > current ? 'forward' : 'backward');
        startAuto();
      });
    });

    section.addEventListener('pdesk:active', () => { startProgressBar(); startAuto(); });
    section.addEventListener('pdesk:inactive', stopAuto);

    // Auto stop quando deixa de ser ativa
    section._pdeskStop = stopAuto;
  }

  // Inicializa todos os sliders
  root.querySelectorAll('.section-snap.hero').forEach(initSlider);

  // Disparar pdesk:inactive ao trocar
  const origUpdate = updateActiveSection;
  updateActiveSection = function () {
    sectionsSnap.forEach((sec, idx) => {
      if (sec && sec._pdeskStop && idx !== currentIndex) sec._pdeskStop();
    });
    origUpdate.apply(this, arguments);
  };

  /* ════════════════════════════════════
     PRODUTOS — Mapa interativo + tabs
     ════════════════════════════════════ */
  const prodSection = root.querySelector('.produtos');
  if (prodSection) {
    const prodTabs = prodSection.querySelectorAll('.produtos__tab');
    const prodBgs = prodSection.querySelectorAll('.produtos__bg');
    const prodPara = prodSection.querySelector('#prod-para');
    const prodDesc = prodSection.querySelector('#prod-desc');
    const prodLink = prodSection.querySelector('#prod-link');
    const mapAreas = prodSection.querySelectorAll('.map-area-predios');

    // Lê dados dos tabs (vindo do Blade)
    const prodData = {};
    prodTabs.forEach(tab => {
      const key = tab.dataset.prod;
      prodData[key] = {
        para: tab.dataset.para || '',
        title: tab.dataset.title || '',
        desc: tab.dataset.desc || '',
        link: tab.dataset.href || '#'
      };
    });

    if (typeof gsap !== 'undefined' && prodPara && prodDesc && prodLink) {
      gsap.set([prodPara, prodDesc, prodLink], { autoAlpha: 0, y: 30 });
    }

    let pinnedProd = 'default';

    function updateProduto(prod) {
      prodTabs.forEach(t => t.classList.toggle('is-active', t.dataset.prod === prod && prod !== 'default'));
      prodBgs.forEach(bg => {
        bg.classList.remove('is-hover');
        bg.classList.toggle('is-active', bg.dataset.prod === prod);
      });

      const elements = [prodPara, prodDesc, prodLink].filter(Boolean);
      if (typeof gsap === 'undefined') {
        if (prodData[prod]) {
          if (prodPara) prodPara.innerHTML = prodData[prod].para;
          if (prodDesc) prodDesc.innerHTML = prodData[prod].desc;
          if (prodLink) { prodLink.href = prodData[prod].link; prodLink.classList.remove('produtos__cta--hidden'); }
        }
        syncDropdown(prod);
        return;
      }

      gsap.killTweensOf(elements);
      if (prodData[prod]) {
        gsap.to(elements, {
          autoAlpha: 0, y: -20, duration: 0.3, ease: 'power2.in',
          onComplete: () => {
            if (prodPara) prodPara.innerHTML = prodData[prod].para;
            if (prodDesc) prodDesc.innerHTML = prodData[prod].desc;
            if (prodLink) prodLink.href = prodData[prod].link;
            gsap.set(elements, { y: 30, autoAlpha: 0 });
            if (prod === 'rooftop' && prodLink) {
              gsap.set(prodLink, { autoAlpha: 0, pointerEvents: 'none' });
            } else if (prodLink) {
              gsap.set(prodLink, { pointerEvents: 'auto' });
              prodLink.classList.remove('produtos__cta--hidden');
            }
            gsap.to(elements, {
              autoAlpha: (i, el) => (el === prodLink && prod === 'rooftop') ? 0 : 1,
              y: 0, duration: 0.8, ease: 'expo.out', stagger: 0.1, clearProps: 'transform'
            });
          }
        });
      } else {
        gsap.to(elements, {
          autoAlpha: 0, y: -20, duration: 0.4, ease: 'power2.in',
          onComplete: () => {
            if (prodPara) prodPara.innerHTML = '';
            if (prodDesc) prodDesc.innerHTML = '';
          }
        });
      }
      syncDropdown(prod);
    }

    function syncDropdown(prod) {
      const dropdownLabel = document.getElementById('dropdown-selected');
      const trigger = document.getElementById('dropdown-trigger');
      const hidden = document.getElementById('f-produto-desk');
      if (dropdownLabel) {
        dropdownLabel.textContent = prodData[prod] ? prodData[prod].title : 'Selecione';
      }
      if (trigger) {
        if (prodData[prod]) trigger.classList.add('has-value'); else trigger.classList.remove('has-value');
      }
      if (hidden && prodData[prod]) hidden.value = prodData[prod].title;
      document.querySelectorAll('.form__dropdown-option').forEach(opt => {
        opt.classList.toggle('is-selected', opt.dataset.value === prod);
      });
    }

    prodTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const prod = tab.dataset.prod;
        pinnedProd = (prod === pinnedProd) ? 'default' : prod;
        updateProduto(pinnedProd);
      });
    });

    function setHoverPreview(prod) {
      prodBgs.forEach(bg => {
        const isPinned = bg.classList.contains('is-active');
        bg.classList.toggle('is-hover', !isPinned && bg.dataset.prod === prod);
      });
    }

    function clearHoverPreview() {
      prodBgs.forEach(bg => bg.classList.remove('is-hover'));
    }

    mapAreas.forEach(area => {
      area.addEventListener('mouseenter', () => setHoverPreview(area.dataset.id));
      area.addEventListener('mouseleave', clearHoverPreview);
      area.addEventListener('click', (e) => {
        e.preventDefault();
        const prod = area.dataset.id;
        pinnedProd = (prod === pinnedProd) ? 'default' : prod;
        updateProduto(pinnedProd);
        clearHoverPreview();
      });
    });
  }

  /* ════════════════════════════════════
     CONTATO DROPDOWN
     ════════════════════════════════════ */
  const trigger = document.getElementById('dropdown-trigger');
  const list = document.getElementById('dropdown-list');
  const selectedText = document.getElementById('dropdown-selected');
  const options = document.querySelectorAll('.form__dropdown-option');

  if (trigger && list) {
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = list.classList.contains('is-open');
      list.classList.toggle('is-open', !isOpen);
      trigger.classList.toggle('is-open', !isOpen);
    });
    options.forEach(opt => {
      opt.addEventListener('click', () => {
        const val = opt.dataset.value;
        if (selectedText) selectedText.textContent = opt.dataset.title || opt.textContent;
        trigger.classList.add('has-value');
        list.classList.remove('is-open');
        trigger.classList.remove('is-open');
        const hidden = document.getElementById('f-produto-desk');
        if (hidden) hidden.value = opt.dataset.title || opt.textContent;
        options.forEach(o => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');
      });
    });
    document.addEventListener('click', () => {
      list.classList.remove('is-open');
      trigger.classList.remove('is-open');
    });
  }

  /* ════════════════════════════════════
     PLANTA MODAL — viewer inline (zoom/pan/minimapa)
     Lê os dados das plantas dos botões .js-floorplan na página.
     ════════════════════════════════════ */
  const plantaModal = document.getElementById('plantaModal');
  if (plantaModal) {
    const tabsEl       = plantaModal.querySelector('#plantaModalTabs');
    const selectEl     = plantaModal.querySelector('#plantaModalSelect');
    const titleEl      = plantaModal.querySelector('#plantaModalTitle');
    const subtitleEl   = plantaModal.querySelector('#plantaModalSubtitle');
    const viewportEl   = plantaModal.querySelector('#plantaModalViewport');
    const canvasEl     = plantaModal.querySelector('#plantaModalCanvas');
    const imgWrapEl    = plantaModal.querySelector('#plantaModalImageWrapper');
    const imgEl        = plantaModal.querySelector('#plantaModalImage');
    const loaderEl     = plantaModal.querySelector('#plantaModalViewportLoader');
    const zoomLevelEl  = plantaModal.querySelector('#plantaModalZoomLevel');
    const minimapEl    = plantaModal.querySelector('#plantaModalMinimap');
    const minimapFrame = plantaModal.querySelector('#plantaModalMinimapFrame');
    const minimapImgEl = plantaModal.querySelector('#plantaModalMinimapImg');
    const minimapVpEl  = plantaModal.querySelector('#plantaModalMinimapVp');

    const MIN_ZOOM = 0.25;
    const MAX_ZOOM = 8;

    let floorPlans = [];
    let currentFloor = 0;
    let scale = 1, translateX = 0, translateY = 0;
    let imgW = 1400, imgH = 900;
    let isDragging = false, dragStartX = 0, dragStartY = 0, dragLastX = 0, dragLastY = 0;
    let zoomAnim = null;
    let targetScale = 1, targetX = 0, targetY = 0;

    let touchStartDist = 0, touchStartScale = 1, touchStartX = 0, touchStartY = 0;
    let touchMidX = 0, touchMidY = 0;

    function collectFloorPlans() {
      const seen = new Set();
      floorPlans = [];
      document.querySelectorAll('.js-floorplan').forEach(btn => {
        const src = btn.dataset.src || '';
        if (!src || seen.has(src)) return;
        seen.add(src);
        floorPlans.push({
          name: btn.dataset.label || 'Planta',
          subtitle: btn.dataset.area || '',
          img: src,
          minimap: btn.dataset.minimap || src,
        });
        btn.dataset.plantaIndex = String(floorPlans.length - 1);
      });
    }

    function buildTabs() {
      tabsEl.innerHTML = '';
      selectEl.innerHTML = '';
      floorPlans.forEach((plan, i) => {
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'planta-modal__tab' + (i === currentFloor ? ' is-active' : '');
        tab.textContent = plan.name;
        tab.addEventListener('click', () => switchFloor(i));
        tabsEl.appendChild(tab);

        const opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = plan.name;
        if (i === currentFloor) opt.selected = true;
        selectEl.appendChild(opt);
      });
    }
    selectEl.addEventListener('change', e => switchFloor(parseInt(e.target.value, 10)));

    function loadFloor(idx, isSwitch) {
      const plan = floorPlans[idx];
      if (!plan) return;
      titleEl.textContent = plan.name;
      subtitleEl.textContent = plan.subtitle;
      if (isSwitch) loaderEl.classList.remove('is-hidden');

      imgEl.src = plan.img;
      minimapImgEl.src = plan.minimap;

      imgEl.onload = () => {
        imgW = imgEl.naturalWidth || imgW;
        imgH = imgEl.naturalHeight || imgH;
        setTimeout(() => {
          loaderEl.classList.add('is-hidden');
          if (isSwitch) imgWrapEl.classList.remove('is-switching');
          zoomFit();
        }, isSwitch ? 300 : 600);
      };
      imgEl.onerror = () => loaderEl.classList.add('is-hidden');
    }

    function switchFloor(idx) {
      if (idx === currentFloor || !floorPlans[idx]) return;
      imgWrapEl.classList.add('is-switching');
      setTimeout(() => {
        currentFloor = idx;
        tabsEl.querySelectorAll('.planta-modal__tab').forEach((t, i) => t.classList.toggle('is-active', i === idx));
        selectEl.value = String(idx);
        loadFloor(idx, true);
      }, 350);
    }

    function applyTransform() {
      imgWrapEl.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
      zoomLevelEl.textContent = Math.round(scale * 100) + '%';
      updateMinimapVp();
    }

    function clampTarget(tx, ty, s) {
      const r = viewportEl.getBoundingClientRect();
      const sw = imgW * s, sh = imgH * s;
      if (sw <= r.width)  tx = (r.width - sw) / 2;
      else                tx = Math.max(r.width - sw, Math.min(0, tx));
      if (sh <= r.height) ty = (r.height - sh) / 2;
      else                ty = Math.max(r.height - sh, Math.min(0, ty));
      return { tx, ty };
    }

    function clampAndApply() {
      const c = clampTarget(translateX, translateY, scale);
      translateX = c.tx; translateY = c.ty;
      applyTransform();
    }

    function animateZoom() {
      if (zoomAnim) cancelAnimationFrame(zoomAnim);
      const s0 = scale, x0 = translateX, y0 = translateY;
      const dur = 250, t0 = performance.now();
      const ease = t => 1 - Math.pow(1 - t, 3);
      const step = now => {
        const p = Math.min(1, (now - t0) / dur);
        const e = ease(p);
        scale = s0 + (targetScale - s0) * e;
        translateX = x0 + (targetX - x0) * e;
        translateY = y0 + (targetY - y0) * e;
        applyTransform();
        if (p < 1) zoomAnim = requestAnimationFrame(step);
        else { zoomAnim = null; applyTransform(); }
      };
      zoomAnim = requestAnimationFrame(step);
    }

    function zoomTo(newScale, pivotX, pivotY) {
      const r = viewportEl.getBoundingClientRect();
      if (pivotX === undefined) { pivotX = r.width / 2; pivotY = r.height / 2; }
      const ratio = newScale / scale;
      const nx = pivotX - ratio * (pivotX - translateX);
      const ny = pivotY - ratio * (pivotY - translateY);
      const c = clampTarget(nx, ny, newScale);
      targetScale = newScale; targetX = c.tx; targetY = c.ty;
      animateZoom();
    }

    function zoomIn()  { zoomTo(Math.min(MAX_ZOOM, scale * 1.3)); }
    function zoomOut() { zoomTo(Math.max(MIN_ZOOM, scale / 1.3)); }

    function zoomFit() {
      const r = viewportEl.getBoundingClientRect();
      if (!r.width || !imgW) return;
      const fit = r.width / imgW;
      targetScale = fit;
      targetX = 0;
      targetY = (r.height - imgH * fit) / 2;
      animateZoom();
    }

    function updateMinimapVp() {
      if (!minimapFrame || !minimapVpEl) return;
      const vp = viewportEl.getBoundingClientRect();
      const mm = minimapFrame.getBoundingClientRect();
      if (!mm.width || !mm.height) return;
      const mmScale = Math.min(mm.width / imgW, mm.height / imgH);
      const renderedW = imgW * mmScale, renderedH = imgH * mmScale;
      const offX = (mm.width - renderedW) / 2, offY = (mm.height - renderedH) / 2;
      const viewX = -translateX / scale, viewY = -translateY / scale;
      const viewW = vp.width / scale, viewH = vp.height / scale;
      let vpL = offX + viewX * mmScale;
      let vpT = offY + viewY * mmScale;
      let vpW = viewW * mmScale;
      let vpH = viewH * mmScale;
      vpL = Math.max(offX, vpL);
      vpT = Math.max(offY, vpT);
      vpW = Math.min(renderedW - (vpL - offX), vpW);
      vpH = Math.min(renderedH - (vpT - offY), vpH);
      minimapVpEl.style.left = vpL + 'px';
      minimapVpEl.style.top = vpT + 'px';
      minimapVpEl.style.width  = Math.max(10, vpW) + 'px';
      minimapVpEl.style.height = Math.max(10, vpH) + 'px';
    }

    /* INTERAÇÕES */
    viewportEl.addEventListener('wheel', e => {
      if (!plantaModal.classList.contains('planta-modal--open')) return;
      e.preventDefault();
      const r = viewportEl.getBoundingClientRect();
      const f = e.deltaY < 0 ? 1.18 : 1 / 1.18;
      const ns = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, scale * f));
      zoomTo(ns, e.clientX - r.left, e.clientY - r.top);
    }, { passive: false });

    canvasEl.addEventListener('mousedown', e => {
      if (e.button !== 0) return;
      isDragging = true;
      dragStartX = e.clientX; dragStartY = e.clientY;
      dragLastX = translateX; dragLastY = translateY;
      canvasEl.classList.add('is-dragging');
    });
    window.addEventListener('mousemove', e => {
      if (!isDragging) return;
      translateX = dragLastX + (e.clientX - dragStartX);
      translateY = dragLastY + (e.clientY - dragStartY);
      clampAndApply();
    });
    window.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      canvasEl.classList.remove('is-dragging');
    });

    canvasEl.addEventListener('touchstart', e => {
      if (e.touches.length === 1) {
        isDragging = true;
        dragStartX = e.touches[0].clientX;
        dragStartY = e.touches[0].clientY;
        dragLastX = translateX; dragLastY = translateY;
      } else if (e.touches.length === 2) {
        isDragging = false;
        touchStartDist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        touchStartScale = scale;
        touchStartX = translateX; touchStartY = translateY;
        touchMidX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        touchMidY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
      }
    }, { passive: true });

    canvasEl.addEventListener('touchmove', e => {
      e.preventDefault();
      const r = viewportEl.getBoundingClientRect();
      if (e.touches.length === 1 && isDragging) {
        translateX = dragLastX + (e.touches[0].clientX - dragStartX);
        translateY = dragLastY + (e.touches[0].clientY - dragStartY);
        clampAndApply();
      } else if (e.touches.length === 2) {
        const dist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        const ns = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, touchStartScale * (dist / touchStartDist)));
        const px = touchMidX - r.left, py = touchMidY - r.top;
        const ratio = ns / touchStartScale;
        translateX = px - ratio * (px - touchStartX);
        translateY = py - ratio * (py - touchStartY);
        scale = ns;
        clampAndApply();
      }
    }, { passive: false });

    canvasEl.addEventListener('touchend', () => { isDragging = false; });

    canvasEl.addEventListener('dblclick', e => {
      const r = viewportEl.getBoundingClientRect();
      const fit = r.width / imgW;
      const ns = scale > fit ? fit : scale * 2.5;
      zoomTo(Math.min(MAX_ZOOM, ns), e.clientX - r.left, e.clientY - r.top);
    });

    minimapFrame.addEventListener('click', e => {
      const mm = minimapFrame.getBoundingClientRect();
      const vp = viewportEl.getBoundingClientRect();
      const cx = e.clientX - mm.left, cy = e.clientY - mm.top;
      const mmScale = Math.min(mm.width / imgW, mm.height / imgH);
      const renderedW = imgW * mmScale, renderedH = imgH * mmScale;
      const offX = (mm.width - renderedW) / 2, offY = (mm.height - renderedH) / 2;
      const ix = (cx - offX) / mmScale, iy = (cy - offY) / mmScale;
      translateX = vp.width / 2 - ix * scale;
      translateY = vp.height / 2 - iy * scale;
      clampAndApply();
    });

    function toggleMinimap() {
      const collapsed = minimapEl.classList.toggle('is-collapsed');
      const btn = minimapEl.querySelector('[data-pm-action="minimap-toggle"]');
      if (btn) btn.title = collapsed ? 'Mostrar minimapa' : 'Ocultar minimapa';
    }

    function toggleFullscreen() {
      const dialog = plantaModal.querySelector('.planta-modal__dialog');
      if (!document.fullscreenElement) dialog?.requestFullscreen?.().catch(() => { });
      else document.exitFullscreen?.();
    }

    plantaModal.addEventListener('click', e => {
      const action = e.target.closest('[data-pm-action]')?.dataset.pmAction;
      if (action === 'close') closePlantaModal();
      else if (action === 'fullscreen') toggleFullscreen();
      else if (action === 'zoom-in') zoomIn();
      else if (action === 'zoom-out') zoomOut();
      else if (action === 'zoom-fit') zoomFit();
      else if (action === 'minimap-toggle') toggleMinimap();
      else if (e.target === plantaModal) closePlantaModal();
    });

    document.addEventListener('keydown', e => {
      if (!plantaModal.classList.contains('planta-modal--open')) return;
      if (e.key === 'Escape') { closePlantaModal(); return; }
      if (e.key === '+' || e.key === '=') zoomIn();
      else if (e.key === '-') zoomOut();
      else if (e.key === '0') zoomFit();
      else if (/^[1-9]$/.test(e.key)) {
        const n = parseInt(e.key, 10) - 1;
        if (floorPlans[n]) switchFloor(n);
      }
    });

    document.addEventListener('fullscreenchange', () => setTimeout(zoomFit, 100));

    function openPlantaModal(idx) {
      if (!floorPlans.length) collectFloorPlans();
      if (!floorPlans.length) return;
      currentFloor = Math.max(0, Math.min(idx | 0, floorPlans.length - 1));
      buildTabs();
      plantaModal.classList.add('planta-modal--open');
      plantaModal.setAttribute('aria-hidden', 'false');
      imgEl.removeAttribute('hidden');
      minimapImgEl.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      loadFloor(currentFloor, false);
    }

    function closePlantaModal() {
      plantaModal.classList.remove('planta-modal--open');
      plantaModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      imgEl.setAttribute('hidden', '');
      minimapImgEl.setAttribute('hidden', '');
    }
    window.closePlantaModal = closePlantaModal;

    collectFloorPlans();
    document.querySelectorAll('.js-floorplan, [id^="open-planta-modal"], .planta__cta[data-open-planta]').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const idx = parseInt(btn.dataset.plantaIndex || '0', 10);
        openPlantaModal(idx);
      });
    });

    window.addEventListener('resize', () => {
      if (plantaModal.classList.contains('planta-modal--open')) zoomFit();
    });
  }

  /* ════════════════════════════════════
     TOUR VIRTUAL MODAL
     ════════════════════════════════════ */
  const tourModal = document.getElementById('tourModal');
  const tourModalContent = document.getElementById('tourModalContent');
  const tourModalTitle = document.getElementById('tourModalTitle');
  const tourModalCloseBtn = document.getElementById('tourModalClose');
  const TOUR_LOADER_HTML = '<div class="tour-modal__loader"><div class="tour-modal__loader-ring"></div><span>Carregando Tour Virtual</span></div>';

  function openTourModal({ title = 'Tour Virtual', url = '' } = {}) {
    if (!tourModal) return;
    if (tourModalTitle) tourModalTitle.textContent = title;
    tourModal.classList.add('is-open');
    tourModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (tourModalContent) {
      tourModalContent.innerHTML = url
        ? `<iframe src="${url}" allowfullscreen loading="lazy" referrerpolicy="origin" allow="fullscreen *; geolocation *; autoplay *; gyroscope *; xr-spatial-tracking *; vr *; web-share *;"></iframe>`
        : TOUR_LOADER_HTML;
    }
  }

  function closeTourModal() {
    if (!tourModal) return;
    tourModal.classList.remove('is-open');
    tourModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(() => {
      if (tourModalContent) tourModalContent.innerHTML = TOUR_LOADER_HTML;
    }, 700);
  }

  tourModalCloseBtn?.addEventListener('click', closeTourModal);
  tourModal?.addEventListener('click', (e) => { if (e.target === tourModal) closeTourModal(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && tourModal?.classList.contains('is-open')) closeTourModal();
  });

  // FAB pills — ações
  document.querySelectorAll('.fab-pill[data-fab-action="tour"] .fab-pill__btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const pill = btn.closest('.fab-pill');
      const url = pill?.getAttribute('data-tourUrl') || '';
      
      const label = pill?.querySelector('.fab-pill__label')?.textContent || 'Tour Virtual';
      openTourModal({ title: label, url });
    });
  });

  /* ════════════════════════════════════
     Resize handler
     ════════════════════════════════════ */
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // Re-bypass se passou para mobile
      if (window.innerWidth <= 768) {
        const slug = root.dataset.slug || '';
        if (slug) window.location.replace('/produto-v3/' + slug);
        return;
      }
      if (lenis && typeof lenis.resize === 'function') lenis.resize();
      // Refresh sections (em caso de DOM mudanças)
      sectionsSnap = Array.from(root.querySelectorAll(':scope > .section-snap'));
      scrollToCurrent(true);
    }, 250);
  });

  /* ════════════════════════════════════
     Init
     ════════════════════════════════════ */
  window.addEventListener('load', () => {
    sectionsSnap = Array.from(root.querySelectorAll(':scope > .section-snap'));
    updateActiveSection();
  });
  updateActiveSection();
})();
